/* eslint-disable camelcase */
import Intercom, { shutdown } from '@intercom/messenger-js-sdk';
import type { User } from 'services/FirebaseService/auth';

const MS_PER_SECOND = 1000;

interface SyncIntercomParams {
  user: User | null;
  enabled: boolean;
}

let intercomStarted = false;

export const hasIntercomStarted = () => intercomStarted;

export const syncIntercom = ({
  user,
  enabled,
}: SyncIntercomParams): boolean => {
  const appId = import.meta.env.VITE_INTERCOM_APP_ID?.trim();

  if (!enabled || !user || !appId) {
    if (window.Intercom) shutdown();
    intercomStarted = false;
    return false;
  }

  Intercom({
    app_id: appId,
    user_id: user.uid,
    name: user.displayName ?? '',
    email: user.email ?? '',
    created_at: Math.floor(
      new Date(user.metadata.creationTime ?? 0).getTime() / MS_PER_SECOND,
    ),
  });

  intercomStarted = true;
  return true;
};

export const initializeIntercom = (user: User) =>
  syncIntercom({ user, enabled: true });

export const shutdownIntercom = () =>
  syncIntercom({ user: null, enabled: false });
